import React from 'react';
import ReactDOM from 'react-dom/client';
import {appRoutes} from './routers/AppRoutes';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.css";
import "./resources/styles/mixtico.css";
import { RouterProvider } from 'react-router-dom';

/*****************************************************************************
 * REVISION 1.0
 * Fecha: 05/03/2023
 *
 * @description Archivo de arranque del FE
 * @author mixtico
 * @version 1.0
 *
 ****************************************************************************/
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router= {appRoutes} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();